import { render, staticRenderFns } from "./CardDeckPreview.vue?vue&type=template&id=1bc11d7c"
import script from "./CardDeckPreview.vue?vue&type=script&lang=js"
export * from "./CardDeckPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports